import React, { FC } from 'react';
import { HeaderLogo } from './logo/HeaderLogo';
import { HeaderDoctrineLogo } from './HeaderDoctrineLogo';

type Props = {
  loggedIn: boolean;
  hideBaseline: boolean;
  source: string;
};

export const HeaderContentLogo: FC<Props> = ({
  loggedIn,
  hideBaseline,
  source,
}) => (
  <HeaderLogo source={source} loggedIn={loggedIn}>
    <HeaderDoctrineLogo hideBaseline={hideBaseline} />
  </HeaderLogo>
);
